module.exports = __webpack_public_path__ + "img/approved.1167e0e0.svg";